var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.034,
    height: 20.279,
    viewBox: "0 0 22.034 20.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5540",
    "data-name": "Group 5540",
    transform: "translate(2997.37 -21503.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5478",
    "data-name": "Group 5478",
    transform: "translate(-2997.37 21503.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4223",
    "data-name": "Rectangle 4223",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#222",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.034,
    height: 20.279,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.6,
    width: 20.834,
    height: 19.079,
    rx: 4.4,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "angle-small-down",
    d: "M17.427,8.182a.906.906,0,0,0-1.287,0l-4.151,4.151a.906.906,0,0,1-1.287,0L6.55,8.182A.907.907,0,0,0,5.263,9.46l4.16,4.16a2.719,2.719,0,0,0,3.843,0l4.16-4.16A.906.906,0,0,0,17.427,8.182Z",
    transform: "translate(-2997.698 21502.84)",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/dropDown.7be95567248149f8d74fc8c4c2c93608.svg";
export { ForwardRef as ReactComponent };